import {
  INotificationTemplate,
  INotificationTemplateHeader,
  INotificationTemplateSignature,
  INotificationTemplateType,
  INotificationType,
  INotificationToken,
  INotificationTokenType,
  INotificationReportInfo,
  ITemplateOption,
} from '../business-objects/common';
import * as actionTypes from './actionTypes';

export interface INotificationTemplateState {
  allNotifications: INotificationTemplate[];
  templateOptions: ITemplateOption[];
  notificationTemplates: INotificationTemplate[];
  templatesByOption: INotificationTemplate[];
  headerTemplates: INotificationTemplateHeader[];
  signatureTemplates: INotificationTemplateSignature[];
  notificationTypes: INotificationType[];
  tokenTypes: INotificationTokenType[];
  storeUpdated: boolean;
  isProcessing: boolean;
  notificationReportInfo: INotificationReportInfo;
}

const initialState: INotificationTemplateState = {
  allNotifications: [],
  templateOptions: [],
  notificationTemplates: [],
  templatesByOption: [],
  headerTemplates: [],
  signatureTemplates: [],
  notificationTypes: [],
  tokenTypes: [],
  storeUpdated: false,
  isProcessing: false,
  notificationReportInfo: null,
};

export default (
  state: INotificationTemplateState = initialState,
  action: any
) => {
  let _state = { ...state };
  switch (action.type) {
    case actionTypes.SAVE_TOKEN_INFO_TO_STORE:
      _state.tokenTypes = action.value; // [..._state.tokenTypes, ...action.value];
      console.log('tokens', _state.tokenTypes);
      return _state;
    case actionTypes.SAVE_NOTIFICATION_INFO_TO_STORE:
      _state.allNotifications = [
        ..._state.allNotifications,
        ...action.value.allActiveNotificationTemplates,
      ];
      _state.headerTemplates = [
        ..._state.headerTemplates,
        ...action.value.allNotificationHeaders,
      ];
      _state.signatureTemplates = [
        ..._state.signatureTemplates,
        ...action.value.allNotificationSignatures,
      ];
      _state.notificationTypes = [
        ..._state.notificationTypes,
        ...action.value.allNotificiationTypes,
      ];
      _state.storeUpdated = true;
      return _state;
    case actionTypes.CREATE_NOTIFICATION_TEMPLATE:
      _state.allNotifications = [..._state.allNotifications, action.value];
      if (
        (action.value as INotificationTemplate).notificationTemplateHeader !=
          null &&
        _state.headerTemplates.filter(
          (item) =>
            item.id ==
            (action.value as INotificationTemplate).notificationTemplateHeader
              .id
        ).length == 0
      )
        _state.headerTemplates = [
          ..._state.headerTemplates,
          action.value.notificationTemplateHeader,
        ];
      if (
        (action.value as INotificationTemplate).notificationTemplateSignature !=
          null &&
        _state.signatureTemplates.filter(
          (item) =>
            item.id ==
            (action.value as INotificationTemplate)
              .notificationTemplateSignature.id
        ).length == 0
      )
        _state.signatureTemplates = [
          ..._state.signatureTemplates,
          action.value.notificationTemplateSignature,
        ];
      return _state;
    case actionTypes.UPDATE_NOTIFICATION_TEMPLATE:
      _state.allNotifications = [
        ..._state.allNotifications.map((notification) =>
          notification.id == action.value.id
            ? { ...notification, ...action.value }
            : notification
        ),
      ];
      if (
        (action.value as INotificationTemplate).notificationTemplateHeader !=
          null &&
        _state.headerTemplates.filter(
          (item) =>
            item.id ==
            (action.value as INotificationTemplate).notificationTemplateHeader
              .id
        ).length == 0
      )
        _state.headerTemplates = [
          ..._state.headerTemplates,
          action.value.notificationTemplateHeader,
        ];
      if (
        (action.value as INotificationTemplate).notificationTemplateSignature !=
          null &&
        _state.signatureTemplates.filter(
          (item) =>
            item.id ==
            (action.value as INotificationTemplate)
              .notificationTemplateSignature.id
        ).length == 0
      )
        _state.signatureTemplates = [
          ..._state.signatureTemplates,
          action.value.notificationTemplateSignature,
        ];
      return _state;
    case actionTypes.TOGGLE_IS_PROCESSING:
      _state.isProcessing = !_state.isProcessing;
      return _state;
    case actionTypes.LOAD_TEMPLATE_OPTIONS_INTO_STORE:
      _state.templateOptions = [...action.value];
      return _state;

    case actionTypes.LOAD_TEMPLATES_BY_OPTION:
      _state = {
        ...state,
        templatesByOption: action.value,
      };
      return _state;
    case actionTypes.GET_NOTIFICATION_REPORT_INFO:
      _state = {
        ...state,
        notificationReportInfo: action.value,
      };
      return _state;
    default:
      return state;
  }
};
